import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ApiVersionComponent } from '@app/components/api-version/api-version.component';
import { environment } from '@env/environment';
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'app-docs-v1',
    imports: [
        HeadMetaComponent,
        ApiVersionComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './page.page.html',
    styleUrl: './page.page.scss'
})
export class DocsV1Page implements OnInit {
  public apiUrl = '';
  public authUrl = '';
  public utilityUrl = '';
  public showApiDocs = false;
  public now = new Date();
  public nowNext = new Date();

  constructor(
    public auth: AuthService
  ){

  }

  ngOnInit(): void {
    this.apiUrl = environment.apiUrl;
    this.authUrl = environment.authUrl;
    this.utilityUrl = environment.utilityUrl;
    this.loadRapiDoc();
    this.now.setHours(this.now.getHours() + 6);
    this.nowNext.setHours(this.nowNext.getHours() + 12);
  }

  private loadRapiDoc(): void {
    if (document.querySelector('script[data-rapidoc]')) return;
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://unpkg.com/rapidoc/dist/rapidoc-min.js';
    script.setAttribute('data-rapidoc', '');
    document.head.appendChild(script);
  }
}
